import { MAActionTypes, MAActionType } from './ma.actions';
import { GetAccountsResponse } from './interfaces';
import { createSelector, createFeatureSelector } from '@ngrx/store';

export interface State {
  accounts: {
    data: GetAccountsResponse;
    isLoading: boolean;
  };
  createdFlowsByMonths: {
    data: any[];
    isLoading: boolean;
  };
  createdFlowsByDays: {
    data: any[];
    isLoading: boolean;
  };
  activeFlows: {
    data: any[];
    isLoading: boolean;
  };
  activeProfiles: {
    data: { day: string; count: number }[];
    isLoading: boolean;
  };
}

export const initialState: State = {
  accounts: {
    data: {},
    isLoading: false,
  },
  createdFlowsByMonths: {
    data: [],
    isLoading: false,
  },
  createdFlowsByDays: {
    data: [],
    isLoading: false,
  },
  activeFlows: {
    data: [],
    isLoading: false,
  },
  activeProfiles: {
    data: [],
    isLoading: false,
  },
};

export function reducer(state = initialState, action: MAActionTypes): State {
  switch (action.type) {
    case MAActionType.GetAccountFlowStatistics:
      return { ...state, accounts: { ...state.accounts, isLoading: true } };

    case MAActionType.GetAccountFlowStatisticsSuccess:
      return { ...state, accounts: { data: action.payload, isLoading: false } };

    case MAActionType.GetAccountFlowStatisticsFail:
      return { ...state, accounts: { data: {}, isLoading: false } };

    case MAActionType.GetActiveProfileInFlows:
      return {
        ...state,
        activeProfiles: { ...state.activeProfiles, isLoading: true },
      };

    case MAActionType.GetActiveProfileInFlowsSuccess:
      return {
        ...state,
        activeProfiles: {
          ...state.activeProfiles,
          isLoading: false,
          data: action.payload,
        },
      };

    case MAActionType.GetActiveProfileInFlowsFail:
      return {
        ...state,
        activeProfiles: { ...state.activeProfiles, isLoading: false },
      };

    case MAActionType.GetCreatedFlowsByDays:
      return {
        ...state,
        createdFlowsByDays: { ...state.createdFlowsByDays, isLoading: true },
      };

    case MAActionType.GetCreatedFlowsByDaysSuccess:
      return {
        ...state,
        createdFlowsByDays: {
          ...state.createdFlowsByDays,
          isLoading: false,
          data: action.payload,
        },
      };

    case MAActionType.GetCreatedFlowsByDaysFail:
      return {
        ...state,
        createdFlowsByDays: { ...state.createdFlowsByDays, isLoading: false },
      };

    case MAActionType.GetCreatedFlowsByMonths:
      return {
        ...state,
        createdFlowsByMonths: {
          ...state.createdFlowsByMonths,
          isLoading: true,
        },
      };

    case MAActionType.GetCreatedFlowsByMonthsSuccess:
      return {
        ...state,
        createdFlowsByMonths: {
          ...state.createdFlowsByMonths,
          isLoading: false,
          data: action.payload,
        },
      };

    case MAActionType.GetCreatedFlowsByMonthsFail:
      return {
        ...state,
        createdFlowsByMonths: {
          ...state.createdFlowsByMonths,
          isLoading: false,
        },
      };

    case MAActionType.GetActiveFlows:
      return {
        ...state,
        activeFlows: {
          ...state.activeFlows,
          isLoading: true,
          data: [],
        },
      };

    case MAActionType.GetActiveFlowsSuccess:
      return {
        ...state,
        activeFlows: {
          ...state.activeFlows,
          isLoading: false,
          data: action.payload,
        },
      };

    case MAActionType.GetActiveFlowsFail:
      return {
        ...state,
        activeFlows: {
          ...state.activeFlows,
          isLoading: false,
        },
      };

    default: {
      return state;
    }
  }
}

const accountFlowStatistics = createFeatureSelector<State>('MA');
export const getAccountFlowStatistics = createSelector(
  accountFlowStatistics,
  (state) => state.accounts.data,
);
export const getCreatedFlowsByMonths = createSelector(
  accountFlowStatistics,
  (state) => state.createdFlowsByMonths.data,
);

export const getIsCreatedFlowsByMonthsLoading = createSelector(
  accountFlowStatistics,
  (state) => state.createdFlowsByMonths.isLoading,
);

export const getCreatedFlowsByDays = createSelector(
  accountFlowStatistics,
  (state) => state.createdFlowsByDays.data,
);

export const getIsCreatedFlowsByDaysLoading = createSelector(
  accountFlowStatistics,
  (state) => state.createdFlowsByDays.isLoading,
);

export const getActiveProfileInFlows = createSelector(
  accountFlowStatistics,
  (state) => state.activeProfiles.data,
);

export const getIsActiveProfileInFlowsLoading = createSelector(
  accountFlowStatistics,
  (state) => state.activeProfiles.isLoading,
);
export const getIsActiveFlowsLoading = createSelector(
  accountFlowStatistics,
  (state) => state.activeFlows.isLoading,
);
export const getActiveFlows = createSelector(
  accountFlowStatistics,
  (state) => state.activeFlows.data,
);
